<template>
  <div>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainFooter from '@/components/footer/MainFooter.vue'

export default {
  components: {MainFooter},

}
</script>

<style>

</style>